import { render, staticRenderFns } from "./CompanyFormPublicView.vue?vue&type=template&id=4b274456&scoped=true"
import script from "./CompanyFormPublicView.vue?vue&type=script&lang=js"
export * from "./CompanyFormPublicView.vue?vue&type=script&lang=js"
import style0 from "./CompanyFormPublicView.vue?vue&type=style&index=0&id=4b274456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b274456",
  null
  
)

export default component.exports